import { formatKilobytes } from './formatBytes'

export const sizeAlertCreator = ({ label, limit }: { label: string; limit: number }) => {
  return {
    title: `The ${label !== 'file' ? label : ''} file is too large`,
    desc: `It must not exceed ${formatKilobytes(limit)}`,
  }
}
